<div class="container mt-3" style="text-align: center;">
  <h5 translate>global.notFound</h5>
  <p>Go to <a href="" routerLink="/">Home</a> page.</p>
</div>